import type { NarrativeUpdate } from '../NarrativeUpdatePanel/narrativeUpdatePanelFragment';
import { NarrativeUpdatePanel } from '../NarrativeUpdatePanel';
import DownSolid from '@simplywallst/ui-core/icons/DownSolid';
import { Button } from '@simplywallst/ui-core/next';
import { useState } from 'react';
import { useTracking } from 'react-tracking';

type Props = {
  updates: NarrativeUpdate[];
};

export const NarrativeUpdateCarousel = ({ updates }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { trackEvent } = useTracking();

  const currentUpdate = updates[currentIndex];
  return (
    <NarrativeUpdatePanel
      update={currentUpdate}
      title={currentIndex === 0 ? 'Last Update' : 'Shared on'}
      actions={
        <div className="grid grid-cols-[max-content_max-content] gap-x1">
          <Button
            variant="subtle"
            size="medium"
            aria-label="Previous Update"
            className="pl-x0_5"
            onClick={() => {
              setCurrentIndex((index) => Math.max(0, index - 1));
              trackEvent({
                action: 'click',
                subject: 'latest_update',
                modifier: 'previous',
              });
            }}
            isDisabled={currentIndex === 0}
          >
            <DownSolid className="rotate-90" /> Previous
          </Button>
          <Button
            variant="subtle"
            size="medium"
            aria-label="Next Update"
            className="pr-x0_5"
            onClick={() => {
              setCurrentIndex((index) =>
                Math.min(updates.length - 1, index + 1)
              );
              trackEvent({
                action: 'click',
                subject: 'latest_update',
                modifier: 'next',
              });
            }}
            isDisabled={currentIndex >= updates.length - 1}
          >
            Next <DownSolid className="-rotate-90" />
          </Button>
        </div>
      }
    />
  );
};
